import React, { Component } from "react";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import { connect } from "react-redux";
import { addSettings } from "../../../actions";
import {
  listCollateralsGroup,
  archiveCollateralsGroup,
  getAttachedFiles,
} from "./../../../config/collateral_apis";
import DataTableExtended from "../../../components/Tables/DataTableExtended";
import { tableLoader } from "../../../components/ContentLoaders/table_loader";
import MsaWarning from "../ExtraComponents/MsaWarning";
import SettingsError from "../ExtraComponents/SettingsError";
import PageTitle from "../ExtraComponents/PageTitle";
import HelperClass from "./../../../config/helperClass";
import { APP_LIVE_URL } from "./../../../config/config";

import Tooltip from "@material-ui/core/Tooltip";
import dateFormat, { masks } from "dateformat";
import UserPermissionHelper from "../../../components/Reseller/UserPermissionHelper";

const auth = new HelperClass();

class CollateralsGroups extends Component {
  constructor() {
    super();

    this.state = {
      errorMessage: "",
      successMessage: "",
      successMessaged: "",
      errorMessaged: "",
      waitMessage: "",
      mainError: "",
      tableLoader: true,
      tableLoaderBundle: true,
      disabled: false,
      main_type: "",
      rate_deck_file: "",
      assigned_agreements: [],
      list_agreements: [],
      package_status: "",
      group_id: "",
      files_details: [],
      archive: "",
      permissionsState: [],
      permission_add: 0,
      permission_edit: 0,
      permission_view: 0,
      permission_delete: 0,
      columnServices: [
        { name: "Seq#" },
        { name: "Title" },
        // {
        //   name: "Status",
        //   options: {
        //     customBodyRender: (value, tableMeta, updateValue) => {
        //       return <div>{this.activeStatus(value, tableMeta)}</div>;
        //     },
        //   },
        // },
        {
          name: "Archive",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return <div>{this.archiveStatus(value, tableMeta)}</div>;
            },
          },
        },
        { name: "id", options: { display: "false" } },
        // {
        //   name: "Actions",
        //   options: {
        //     customBodyRender: (value, tableMeta, updateValue) => {
        //       return (
        //         <div>
        //           <div
        //             className="nk-tb-col nk-tb-col-tools"
        //             style={{ padding: "0px" }}
        //           >
        //             <ul className="nk-tb-actions gx-1">
        //               <li>
        //                 <div className="drodown">
        //                   <a
        //                     style={{ cursor: "pointer" }}
        //                     title="Other Actions"
        //                     className="dropdown-toggle btn btn-icon  btn-outline-light"
        //                     data-toggle="dropdown"
        //                   >
        //                     <em className="icon ni ni-more-h"></em>
        //                   </a>
        //                   <div className="dropdown-menu dropdown-menu-right">
        //                     <ul className="link-list-opt no-bdr">
        //                       <li>
        //                         <Tooltip title="Edit Group" placement="top">
        //                           <a
        //                             style={{ cursor: "pointer" }}
        //                             onClick={() =>
        //                               this.addMenuHistory(
        //                                 "/Collaterals/edit_group/" +
        //                                   tableMeta.rowData[3]
        //                               )
        //                             }
        //                             disabled={
        //                               this.props.is_msa_signed === "No" ||
        //                               this.props.defaultSettings === "missing"
        //                                 ? true
        //                                 : false
        //                             }
        //                           >
        //                             <em className="icon ni ni-edit"></em>
        //                             <span> Edit </span>
        //                           </a>
        //                         </Tooltip>
        //                       </li>
        //                       <li>
        //                         <Tooltip title="Archive Group" placement="top">
        //                           <a
        //                             style={{ cursor: "pointer" }}
        //                             onClick={() =>
        //                               this.ArchiveServiceType(value, tableMeta)
        //                             }
        //                             disabled={
        //                               this.props.is_msa_signed === "No" ||
        //                               this.props.defaultSettings === "missing"
        //                                 ? true
        //                                 : false
        //                             }
        //                           >
        //                             {tableMeta.rowData[2] === "0" ? (
        //                               <>
        //                                 <em className="icon ni ni-archive"></em>
        //                                 <span> Archive </span>
        //                               </>
        //                             ) : (
        //                               <>
        //                                 <em className="icon ni ni-unarchive"></em>
        //                                 <span> Unarchive </span>
        //                               </>
        //                             )}
        //                           </a>
        //                         </Tooltip>
        //                       </li>
        //                       <li>
        //                         <a
        //                           style={{ cursor: "pointer" }}
        //                           onClick={() =>
        //                             this.openAttachedFile(value, tableMeta)
        //                           }
        //                           data-toggle="tooltip"
        //                           data-placement="top"
        //                           title="Show signee details"
        //                           disabled={
        //                             this.props.is_msa_signed === "No" ||
        //                             this.props.defaultSettings === "missing"
        //                               ? true
        //                               : false
        //                           }
        //                         >
        //                           <em className="icon ni ni-table-view"></em>
        //                           <span>Attached File</span>
        //                         </a>
        //                       </li>
        //                     </ul>
        //                   </div>
        //                 </div>
        //               </li>
        //             </ul>
        //           </div>
        //         </div>
        //       );
        //     },
        //   },
        // },
        {
          name: "Actions",
          label: "Actions",
          options: {
            customBodyRender: (value, tableMeta) => {
              const isDisabled =
                this.props.is_msa_signed === "No" ||
                this.props.defaultSettings === "missing";

              const groupId = tableMeta.rowData[3];
              const isArchived = tableMeta.rowData[2] !== "0"; // "0" => active

              return (
                <>
                  {this.state.permissionsState &&
                  this.state.permissionsState.length > 0 &&
                  (this.state.permission_edit === 1 ||
                    this.state.permission_view === 1 ||
                    this.state.permission_delete === 1) ? (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 8,
                        minHeight: 36,
                      }}
                    >
                      {/* Edit Group */}
                      {this.state.permissionsState &&
                      this.state.permissionsState.length > 0 &&
                      this.state.permission_edit === 1 ? (
                        <Tooltip title="Edit Group" placement="top">
                          <a
                            onClick={() => {
                              if (isDisabled) return;
                              this.addMenuHistory(
                                `/Collaterals/edit_group/${groupId}`
                              );
                            }}
                            style={{
                              cursor: isDisabled ? "not-allowed" : "pointer",
                              opacity: isDisabled ? 0.3 : 1,
                            }}
                          >
                            <em
                              className="icon ni ni-edit text-primary"
                              style={{ fontSize: 20 }}
                            />
                          </a>
                        </Tooltip>
                      ) : null}

                      {/* Archive / Unarchive */}
                      {this.state.permissionsState &&
                      this.state.permissionsState.length > 0 &&
                      this.state.permission_delete === 1 ? (
                        <Tooltip
                          title={
                            isArchived ? "Unarchive Group" : "Archive Group"
                          }
                          placement="top"
                        >
                          <a
                            onClick={() => {
                              if (isDisabled) return;
                              this.ArchiveServiceType(value, tableMeta);
                            }}
                            style={{
                              cursor: isDisabled ? "not-allowed" : "pointer",
                              opacity: isDisabled ? 0.3 : 1,
                            }}
                          >
                            {isArchived ? (
                              <em
                                className="icon ni ni-unarchive-fill text-danger"
                                style={{
                                  fontSize: 20,
                                  paddingLeft: 5,
                                  borderLeft:
                                    this.state.permission_edit === 1
                                      ? "1px solid rgb(0 0 0 / 87%)"
                                      : "none",
                                }}
                              />
                            ) : (
                              <em
                                className="icon ni ni-archive text-danger"
                                style={{
                                  fontSize: 20,
                                  paddingLeft: 5,
                                  borderLeft:
                                    this.state.permission_edit === 1
                                      ? "1px solid rgb(0 0 0 / 87%)"
                                      : "none",
                                }}
                              />
                            )}
                          </a>
                        </Tooltip>
                      ) : null}

                      {/* Attached File */}
                      {this.state.permissionsState &&
                      this.state.permissionsState.length > 0 &&
                      this.state.permission_view === 1 ? (
                        <Tooltip title="Attached File" placement="top">
                          <a
                            onClick={() => {
                              if (isDisabled) return;
                              this.openAttachedFile(value, tableMeta);
                            }}
                            style={{
                              cursor: isDisabled ? "not-allowed" : "pointer",
                              opacity: isDisabled ? 0.3 : 1,
                            }}
                          >
                            <em
                              className="icon ni ni-table-view text-secondary"
                              style={{
                                fontSize: 20,
                                paddingLeft: 5,
                                borderLeft:
                                  this.state.permission_delete === 1 ||
                                  this.state.permission_edit === 1
                                    ? "1px solid rgb(0 0 0 / 87%)"
                                    : "none",
                              }}
                            />
                          </a>
                        </Tooltip>
                      ) : null}
                    </div>
                  ) : (
                    "---"
                  )}
                </>
              );
            },
          },
        },
      ],
    };
  }

  // activeStatus = (value, tableMeta) => {
  //   let status = tableMeta.rowData[2];
  //   if (status === "1") {
  //     return <span className="badge badge-outline-success">Active</span>;
  //   } else {
  //     return <span className="badge badge-outline-danger">Inactive</span>;
  //   }
  // };

  archiveStatus = (value, tableMeta) => {
    let status = tableMeta.rowData[2];
    if (status === "0") {
      return <span className="badge badge-outline-success">No</span>;
    } else {
      return <span className="badge badge-outline-danger">Yes</span>;
    }
  };

  viewBtns = () => {
    if (
      this.props.is_msa_signed === "No" ||
      this.props.defaultSettings === "missing"
    ) {
      return <VisibilityOffIcon />;
    } else {
      return <VisibilityIcon style={{ cursor: "pointer" }} />;
    }
  };

  ArchiveServiceType = (value, tableMeta) => {
    let group_id = tableMeta.rowData[3];
    let archive = tableMeta.rowData[2];
    this.setState({
      group_id: group_id,
      archive: archive,
      errorMessaged: "",
      successMessaged: "",
      disabled: false,
    });
    window.$("#modalDeleteAlert").modal("show");
  };

  modalHideDel = () => {
    window.$("#modalDeleteAlert").modal("hide");
  };

  actionArchiveServiceType = async () => {
    let group_id = this.state.group_id;
    let archive = this.state.archive;
    this.setState({
      disabled: true,
    });
    const agreementResponce = await archiveCollateralsGroup(
      auth.getAccount(),
      auth.getToken(),
      group_id,
      archive
    );
    // console.log("status: ", agreementResponce.data);
    if (
      agreementResponce.data.status === 403 ||
      agreementResponce.data.errors === "authentication missing" ||
      agreementResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      agreementResponce.data.status === 404 &&
      agreementResponce.data.message === "fail"
    ) {
      // window.location.replace("/error");
      this.setState({
        errorMessaged: agreementResponce.data.message,
        successMessaged: "",
        disabled: false,
      });
      //$("#btnloader").hide();
    } else if (
      agreementResponce.data.status === 200 &&
      agreementResponce.data.message === "success"
    ) {
      let archive = this.state.archive;
      var message = "";
      if (archive == 1) {
        message = "Group unarchived successfully.";
      } else {
        message = "Group archived successfully.";
      }
      this.setState({
        errorMessaged: "",
        successMessaged: message,
        disabled: false,
      });
      setTimeout(function () {
        window.$("#modalDeleteAlert").modal("hide");
        window.location.reload();
      }, 3000);
    } else {
      this.setState({
        errorMessaged: agreementResponce.data.message,
        successMessaged: "",
        disabled: false,
      });
    }
  };

  openAttachedFile = async (value, tableMeta) => {
    let group_id = tableMeta.rowData[3];
    this.setState({
      files_details: [],
    });
    const servicesResponce = await getAttachedFiles(
      auth.getAccount(),
      auth.getToken(),
      group_id
    );
    // console.log("openAttachedFile.data: ", servicesResponce.data);
    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      servicesResponce.data.status === 404 &&
      servicesResponce.data.message === "Files not found"
    ) {
      this.setState({
        approveErrorMessage: "Signee details not found.",
      });
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      this.setState({
        files_details: servicesResponce.data.data,
      });
    } else {
      this.setState({
        approveErrorMessage:
          "There is an error while displaying the attached files. Please try again.",
        disabled: false,
      });
    }
    //
    window.$("#modalAttachedFiles").modal("show");
  };

  format_date = (value, tableMeta) => {
    let date = value;
    return dateFormat(date, "mm-dd-yyyy, h:MM:ss TT");
  };

  async componentDidMount() {
    const servicesResponce = await listCollateralsGroup(
      auth.getAccount(),
      auth.getToken()
    );
    // console.log("servicesResponce.data.data: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      this.setState({
        tableData: [],
        mainError: "There is some error while getting the services Types",
      });
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      this.setState({
        tableData: servicesResponce.data.data,
        tableLoader: false,
      });
    } else {
      this.setState({
        tableData: [],
        mainError: "There is some error while getting the services",
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.userRoleItems !== this.props.userRoleItems) {
      const canEdit = UserPermissionHelper.getAllRoles(
        this.props.userRoleItems,
        "documents",
        "document_groups"
      );
      // console.log("Can Edit Clients:", canEdit);

      this.setState({
        permissionsState: canEdit,
        permission_add: canEdit[0].add,
        permission_edit: canEdit[0].edit,
        permission_view: canEdit[0].view,
        permission_delete: canEdit[0].delete,
      });
      //console.log("Can Edit Clients:", canEdit);
    }
  }

  viewDownloadBtns = (filepath) => {
    if (filepath && filepath !== "") {
      return (
        <div>
          <a
            onClick={() => this.downloadCreditAppPdf(filepath)}
            style={{ cursor: "pointer" }}
            title="Download Document"
          >
            <span className="badge badge-outline-secondary">
              {" "}
              <em className="icon ni ni-file-pdf"></em> View Document
            </span>
          </a>
        </div>
      );
    } else {
      return (
        <div>
          <span className="badge badge-outline-light">
            {" "}
            <em className="icon ni ni-file-pdf"></em> View Document
          </span>
        </div>
      );
    }
  };

  handleDownload = async (d_f_name) => {
    //this.setState({ processing_request: true });
    var url = APP_LIVE_URL + "files_data/collaterals/" + d_f_name;
    // console.log("url: ", url);
    let file_name = d_f_name;
    fetch(url)
      .then((x) => x.blob())
      .then((b) => {
        // console.log("B INSTANCE", b instanceof Blob);
        const url = window.URL.createObjectURL(b);
        var a = document.createElement("a");
        document.body.appendChild(a);
        a.style = "display: none";
        a.href = url;
        a.download = file_name;
        a.click();
        window.URL.revokeObjectURL(url);
        //this.setState({ processing_request: false });
      });
  };

  addMenuHistory = (link) => {
    this.props.props.history.push(link);
  };

  render() {
    return (
      <div className="nk-content " id="Services_Block">
        <div className="container-fluid">
          {this.props.defaultSettings === "missing" &&
          this.props.from !== "dashboard" ? (
            <SettingsError />
          ) : null}
          {/* MSA WARNING  START*/}
          {this.props.is_msa_signed === "No" &&
          this.props.from !== "dashboard" ? (
            <MsaWarning />
          ) : null}

          {/* MSA WARNING END */}

          <div className="nk-content-inner">
            <div className="nk-content-body">
              {/* PAGE TITLE START */}
              <div className="nk-block-head nk-block-head-sm">
                <div className="nk-block-between">
                  <div className="nk-block-head-content">
                    <h3 className="nk-block-title page-title">
                      <PageTitle
                        name="Document Groups"
                        icon="icon ni ni-link-group"
                      />
                    </h3>
                  </div>
                  <div className="nk-block-head-content" id="HeadContentAgent">
                    <div className="toggle-wrap nk-block-tools-toggle">
                      <a
                        href="#"
                        className="btn btn-icon btn-trigger toggle-expand mr-n1"
                        data-target="pageMenu"
                      >
                        <em className="icon ni ni-more-v"></em>
                      </a>
                      <div
                        className="toggle-expand-content"
                        data-content="pageMenu"
                      >
                        <ul className="nk-block-tools g-3">
                          {this.state.permissionsState &&
                          this.state.permissionsState.length > 0 &&
                          this.state.permission_add === 1 ? (
                            <li className="nk-block-tools-opt">
                              <a
                                style={{ cursor: "pointer", color: "#fff" }}
                                onClick={() =>
                                  this.addMenuHistory("/Collaterals/addGroup")
                                }
                                className="btn btn-primary"
                              >
                                <em className="icon ni ni-plus"></em> Add New
                              </a>
                            </li>
                          ) : null}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* PAGE TITLE END */}
              <div className="nk-block">
                <div className="row g-gs">
                  {/* Table 5th Col Start */}
                  <div className="col-xxl-12">
                    <div className="nk-block nk-block-lg">
                      <div className="card card-bordered">
                        <div className="card-inner">
                          {this.state.mainError !== "" ? (
                            <div className="example-alert">
                              <div className="alert alert-pro alert-danger">
                                <div className="alert-text">
                                  <h4>Error</h4>
                                  <p>{this.state.mainError}</p>
                                </div>
                              </div>
                            </div>
                          ) : null}
                          {/* START DATATABLE */}
                          {this.state.tableLoader === true ? (
                            tableLoader()
                          ) : (
                            <DataTableExtended
                              columns={this.state.columnServices}
                              tableData={this.state.tableData}
                              title=""
                            />
                          )}

                          {/* END TABLE */}
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Table 5th Col End */}
                </div>
              </div>
              {/* START DELETE MODAL  */}
              <div className="modal fade" tabIndex="-1" id="modalDeleteAlert">
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <a
                      style={{ cursor: "pointer" }}
                      className="close"
                      onClick={() => {
                        this.modalHideDel();
                      }}
                    >
                      <em className="icon ni ni-cross"></em>
                    </a>
                    <div className="modal-body modal-body-lg text-center">
                      <div className="nk-modal">
                        <em className="nk-modal-icon icon icon-circle icon-circle-xxl ni ni-trash bg-success"></em>
                        {this.state.archive === "0" ? (
                          <h4 className="nk-modal-title">Archive Group?</h4>
                        ) : (
                          <h4 className="nk-modal-title">Unarchive Group?</h4>
                        )}

                        <div className="nk-modal-text">
                          {this.state.errorMessaged !== "" ? (
                            <div
                              className="example-alert"
                              style={{ marginBottom: "15px" }}
                            >
                              <div className="alert alert-pro alert-danger">
                                <div className="alert-text">
                                  <h4>Error</h4>
                                  <p>{this.state.errorMessaged}</p>
                                </div>
                              </div>
                            </div>
                          ) : null}
                          {this.state.successMessaged !== "" ? (
                            <div
                              className="example-alert"
                              style={{ marginBottom: "15px" }}
                            >
                              <div className="alert alert-pro alert-success">
                                <div className="alert-text">
                                  <h4>Success</h4>
                                  <p>{this.state.successMessaged}</p>
                                </div>
                              </div>
                            </div>
                          ) : null}
                          {this.state.archive === "0" ? (
                            <div className="caption-text">
                              Are you sure you want to Archive this Service
                              Type?
                            </div>
                          ) : (
                            <div className="caption-text">
                              Are you sure you want to Unarchive this Service
                              Type?
                            </div>
                          )}
                        </div>
                        <div className="nk-modal-action">
                          <button
                            style={{ cursor: "pointer" }}
                            className="btn btn-lg btn-mw btn-primary"
                            onClick={() => {
                              this.modalHideDel();
                            }}
                          >
                            CANCEL
                          </button>
                          {"  "}
                          <button
                            style={{ cursor: "pointer" }}
                            className={
                              this.state.archive === "0"
                                ? "btn btn-lg btn-mw btn-danger"
                                : "btn btn-lg btn-mw btn-success"
                            }
                            onClick={() => {
                              this.actionArchiveServiceType();
                            }}
                            disabled={this.state.disabled ? true : false}
                          >
                            {this.state.archive === "0"
                              ? "ARCHIEVE"
                              : "UNARCHIEVE"}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* END DELETE MODAL  */}
              {/**** Open Signee Details Modal ***/}
              <div className="modal fade" tabIndex="-1" id="modalAttachedFiles">
                <div
                  className="modal-dialog modal-xl modal-dialog-top"
                  role="document"
                >
                  <div className="modal-content">
                    <a
                      href="#"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <em className="icon ni ni-cross"></em>
                    </a>
                    <div className="modal-header">
                      <h5 className="modal-title">Attached Files</h5>
                    </div>
                    <div className="modal-body">
                      <div className="g-4">
                        <div id="no-more-tables-new">
                          <table className="table table-bordered">
                            <thead className="thead-light">
                              <tr>
                                <th className="tb-col-os">
                                  <span className="overline-title">Title</span>
                                </th>
                                <th className="tb-col-os">
                                  <span className="overline-title">For</span>
                                </th>
                                <th className="tb-col-os">
                                  <span className="overline-title">Type</span>
                                </th>
                                <th className="tb-col-ip">
                                  <span className="overline-title">Download</span>
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {this.state.files_details &&
                              this.state.files_details.length > 0 ? (
                                <>
                                  {this.state.files_details.map(
                                    (details, index) => (
                                      <tr key={`idx${index}`}>
                                        <td className="tb-col-os">
                                          {details[0]} {/* Displaying Title */}
                                        </td>
                                        <td className="tb-col-os">
                                          {details[2]} {/* Displaying agents */}
                                        </td>
                                        <td className="tb-col-os">
                                          {details[1]} {/* Displaying pdf */}
                                        </td>
                                        <td className="tb-col-os">
                                          <span
                                            className="badge badge-outline-primary"
                                            onClick={() =>
                                              this.handleDownload(details[3])
                                            } // Call handleDownload function with file URL
                                            style={{ cursor: "pointer" }}
                                          >
                                            <em
                                              className="icon ni ni-download"
                                              style={{ fontSize: "18px" }}
                                            ></em>
                                          </span>
                                        </td>
                                      </tr>
                                    )
                                  )}
                                </>
                              ) : (
                                <tr>
                                  <td className="tb-col-os" colSpan={4}>
                                    <strong className="text-danger">
                                      Record not found
                                    </strong>
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/**** Open Signee Details Modal ***/}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    defaultSettings: state.settings,
    is_msa_signed: state.is_msa_signed,
    userRoleItems: state.userRoleItems,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    addSettings: (payload) => dispatch(addSettings(payload)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(CollateralsGroups);
